import { render, staticRenderFns } from "./AppMessageBox.vue?vue&type=template&id=3de52342&scoped=true&"
import script from "./AppMessageBox.vue?vue&type=script&lang=js&"
export * from "./AppMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./AppMessageBox.vue?vue&type=style&index=0&id=3de52342&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de52342",
  null
  
)

export default component.exports